const navLinks = document.querySelector('.menu-drawer-container');

// Gallery
const mainGallery = document.getElementById('main-image');
const galleryThumbs = document.querySelectorAll('.gallery-thumb');

galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
        const imgSrc = thumb.dataset.img;
        mainGallery.src = imgSrc;
        
        // Update active thumb
        galleryThumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
    });
});

// Smooth Scrolling
document.querySelectorAll('a[href*="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {

        const url = new URL(this.href);
        const isSamePage =
            url.pathname === window.location.pathname && // same page
            url.origin === window.location.origin;        // same domain

        // If it's NOT the same page -> let it navigate normally
        if (!isSamePage) return;

        // SAME PAGE: Use smooth scrolling
        e.preventDefault();

        const hash = url.hash; // extract "#id"
        const target = document.querySelector(hash);

        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });

            // Close mobile menu if open
            navLinks.classList.remove('menu-opening');
            navLinks.removeAttribute('open');
            document.body.classList.remove('overflow-hidden-tablet');
            const summary = navLinks.querySelector('summary');
            if (summary) {
                summary.setAttribute('aria-expanded', 'false');
            }
        }
    });
});

// Parallax effect on scroll
window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const parallax = document.querySelector('.hero-bg-animation');
    if (parallax) {
        parallax.style.transform = `translateY(${scrolled * 0.5}px)`;
    }
});

// Add animation on scroll
const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
        }
    });
}, observerOptions);

// Observe feature cards and model cards
document.querySelectorAll('.feature-card, .model-card, .step-card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
});

// "More below" cue in the fit-check popup: shown while there is content under the fold, hidden near the end
function updateScrollIndicator() {
    const container = document.getElementById('popupContainer');
    const indicator = document.getElementById('scrollIndicator');
    if (!container || !indicator) return;
    const overflowing = container.scrollHeight > container.clientHeight + 4;
    const nearEnd = container.scrollTop + container.clientHeight >= container.scrollHeight - 60;
    indicator.style.display = overflowing && !nearEnd ? 'block' : 'none';
}

function checkScrollIndicator() {
    const container = document.getElementById('popupContainer');
    if (!container) return;
    // one listener, however many times the popup is opened
    if (!container.dataset.scrollCue) {
        container.dataset.scrollCue = 'on';
        container.addEventListener('scroll', updateScrollIndicator, { passive: true });
    }
    updateScrollIndicator();
}

// One screen at a time, so the connector step and the confirm box are never skipped over
function scrollPopupDown() {
    const container = document.getElementById('popupContainer');
    if (!container) return;
    container.scrollBy({
        top: Math.round(container.clientHeight * 0.75),
        behavior: 'smooth'
    });
}

function closePopup() {
    document.getElementById('popupOverlay').classList.remove('active');
    document.body.style.overflow = 'auto';
}

function confirmAndAdd() {
    // Show success state
    document.getElementById('popupContainer').classList.remove('active');
    document.getElementById('popupConfirmAddedtocart').classList.add('active');
    
    // In real implementation, this would add to cart
    setTimeout(() => {
        closePopup();
        document.getElementById('popupContainer').classList.add('active');
        document.getElementById('popupConfirmAddedtocart').classList.remove('active');
    }, 3000);
}

// Close on ESC key
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
        closePopup();
    }
});

// Smooth Scrolling
function scrollToSection(selector) {
    const target = document.querySelector(selector);
    if (target) {
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}

// Update Buy Now buttons to scroll to version selection
document.querySelectorAll('.nav-cta').forEach(btn => {
    btn.addEventListener('click', function(e) {
        if (this.getAttribute('href') === '#comparison-section') {
            e.preventDefault();
            scrollToSection('#comparison-section');
        }
    });
});

// Parallax on scroll (desktop only)
if (window.innerWidth > 768) {
    window.addEventListener('scroll', () => {
        const scrolled = window.pageYOffset;
        const pageBackground = document.querySelector('.page-background');
        if (pageBackground) {
            pageBackground.style.transform = `translateY(${scrolled * 0.5}px)`;
        }
    });
}

// Animate on scroll
const animateObserverOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
};

const animateObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
        }
    });
}, animateObserverOptions);

document.querySelectorAll('.version-card, .model-card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    animateObserver.observe(el);
});

// Scroll-based CTA visibility
let lastScroll = 0;
const floatingCta = document.querySelector('.floating-cta');

window.addEventListener('scroll', () => {
    const scrollPosition = window.scrollY;
    const detailsSection = document.querySelector('.scroll-details');
    // pages without that section (and pages without the floating button) have nothing to toggle
    if (!detailsSection || !floatingCta) return;
    const detailsPosition = detailsSection.offsetTop;

    // Show floating side CTA when user scrolls to details section
    if (scrollPosition > detailsPosition - 200) {
        floatingCta.classList.add('visible');
    } else {
        floatingCta.classList.remove('visible');
    }

    lastScroll = scrollPosition;
});